import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter, getDocsFromServer, startAt, endAt } from '@angular/fire/firestore';

import { take, map } from 'rxjs/operators';

import { Team, TeamGroup, Player, Event, Mission } from '../classes/index';

import moment from 'moment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable()
export class TeamService {

	constructor(
		private http: HttpClient,
		private firestore: Firestore
	) { }

	listTeams(gameId){
		return collectionData(query(collection(this.firestore, `games/${gameId}/teams`)), { idField: 'id' })
		//.valueChanges({ idField: 'id' })
		.pipe(map(teams => {
			return teams.map(data => {
				let team = new Team();
				team.fromJSON(data);
				return team;
			});
		}));
	}

	getLastTeam(gameId){
		return getDocsFromServer(query(collection(this.firestore, `games/${gameId}/teams`), orderBy('startTime','desc'), limit(1)))
		.then(data => {
			return data.docs.map(doc => {
				let team = new Team();
				team.fromJSON(doc.data());
				team.id = doc.id;
				return team;
			});
		});
	}

	listLeaderboardTeams(gameId, groupId, limit){
		let teamQuery = query(collection(this.firestore, `games/${gameId}/teams`));
		if(groupId){
			teamQuery = query(teamQuery, where('groupId','==',groupId), orderBy('score','desc'));
			if(limit>0){
				teamQuery = query(teamQuery, where('groupId','==',groupId), orderBy('score','desc'), limit(limit));
			}
		}
		else if(limit>0){
			teamQuery = query(teamQuery, orderBy('score','desc'), limit(limit));
		}
		return collectionData(teamQuery, { idField: 'id' })
		.pipe(map(teams => {
			return teams.map(data => {
				let team = new Team();
				team.fromJSON(data);
				return team;
			});
		}))	;
	}

	listTeamPositions(gameId){
		return collectionData(query(collection(this.firestore, `games/${gameId}/teams_position`)), { idField: 'id' });
	}

	async listJournalTeam(newValue, gameId, teamId, game){
		let teamData:any = {...newValue};
        let players = [], objects, missions = [] 
		teamData.players = await this.listTeamPlayers(gameId, teamId).pipe(take(1)).toPromise();
		missions = await this.listTeamMissions(gameId, teamId).pipe(take(1)).toPromise()
		console.log()
        //teamData.missions = missions;
        teamData.riddleCount = missions.filter(function( mission ) {return mission.complete && mission.type == 'REWARD' && mission.rewardMode == 'RIDDLE'}).length;
        teamData.clueCount = 0;
        teamData.missionCount = 0;
        for(let mission of missions){
            if(mission.complete){
                teamData.missionCount++;
            }
            if(mission.takenClues){
                for(let clueId in mission.takenClues){
                    let clue = mission.takenClues[clueId];
                    if(clue.activated){
                        teamData.clueCount++;
                    }
                }
            }
        }
		/**
			this.afs.doc(`games/${gameId}`).collection('teams').doc(teamId).collection('objects').get().pipe(take(1))
			.subscribe(async teamObjects => {
				if(teamObjects) teamData.objects = objects;
			});

			this.afs.doc(`games/${gameId}/teams/${teamId}`).collection('events').get().pipe(take(1)).subscribe(async events => {
				if(events) teamData.events = events;
			});
			let events = [];
			let picCount = 0;
			for(let event of events){
				if(event.type == 'PICTURE_PROOF_SENT' && event.thumbFileURL){
					teamData.teamPictureUrl = event.thumbFileURL;
					picCount++;
					if(!event.galleryCopyDate){
						let data = {
							gameId: gameId,
							gameName: game.data().name,
							teamId: teamId,
							eventId: event.id,
							teamName: teamData.name || 'unknown',
							fileURL: event.fileURL,
							thumbFileURL: event.thumbFileURL,
							fileName: event.fileName,
							time: event.time
						};
						await firebase.firestore().collection('games').doc(gameId).collection('teampictures').add(data);
						const eventRef = firebase.firestore().doc(`games/${gameId}/teams/${teamId}/events/${event.id}`);
						await eventRef.update({galleryCopyDate:new Date().getTime()});
					}
				}
			}
			teamData.freeGames = await this.gameService.listFreeeGame() 
		*/
		if(teamData.score) {
			console.log('teamData :',teamData)
			console.log('groupId :',teamData.groupId)
			let teamsQuerySnapshot
			if(teamData.groupId){
				teamsQuerySnapshot = await getDocs(query(collection(this.firestore, `games/${gameId}/teams`), 
				where("score", ">", teamData.score), where("groupId", "==", teamData.groupId)))
			} 
			else {
				teamsQuerySnapshot = await getDocs(query(collection(this.firestore, `games/${gameId}/teams`), 
				where("score", ">", teamData.score)))
			}
			console.log('teamsQuerySnapshot docs :',teamsQuerySnapshot.docs)
			teamData.leaderboardPosition = teamsQuerySnapshot.docs.length+1;

			console.log('leaderboardPosition :',teamData.leaderboardPosition)

		}else teamData.leaderboardPosition = 0
        //LEADERBOARD
        const topTeamsQuerySnapshot = await getDocs(query(collection(this.firestore, `games/${gameId}/teams`), 
        	orderBy('score', 'desc'), limit(10)))
        let teamCount = 0;
        let teams = [];
        for (const teamSnapshot of topTeamsQuerySnapshot.docs) {
            if(teamSnapshot.id !== 'test_team' && teamSnapshot.data().initiated){
                teamCount++;
                teams.push({id:teamSnapshot.id, position:teamCount, team:teamSnapshot.data().name, points:teamSnapshot.data().score});
            }
        }
        teamData.leaderboard = teams;
        teamData.duration = newValue.duration
        teamData.startTime = newValue.startTime
        teamData.stopTime = newValue.stopTime
		return teamData
	}

	getBlogGame(gameId, lang){
		return this.http.get(`https://www.coddygames.com/${lang}/exports/api/posts/${gameId}/${environment.webAppKey}`);
	}

	getRelatedGames(gameId, lang){
		return this.http.get(`https://www.coddygames.com/${lang}/exports/api/games/${gameId}/${environment.webAppKey}`);
	}

	listTodayTeams(){
		// Get all the user's comments, no matter how deeply nested
		var start = moment().utc().startOf('day').valueOf(); 
    	var end = moment().utc().endOf('day').valueOf(); 
    	console.log('compute stats from '+start+' to '+end);
    	//Teams started per game
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where("startTime", ">=", start), 
		where("startTime", "<=", end), orderBy('startTime','desc')), { idField: 'id' });
	}

	listEmptyTeams(){
    	console.log('listEmptyTeams');
    	//Teams started per game
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where("startTime", ">=", 0), 
		where("complete", "==", false), orderBy('startTime','asc')), { idField: 'id' });
	}

	listTodayTeamsMobile(){
		// Get all the user's comments, no matter how deeply nested
		var start = moment().utc().startOf('day').valueOf(); 
    	var end = moment().utc().endOf('day').valueOf(); 
    	console.log('compute stats from '+start+' to '+end);
    	//Teams started per game
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where("startTime", ">=", start), 
		where("startTime", "<=", end), orderBy('startTime','desc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	listAllTeamsByGame(dateTimeDebut, dateTimeFin, gameId){
		if(dateTimeDebut && dateTimeFin){
			var start = moment(dateTimeDebut).startOf('day').valueOf();
			var end = moment(dateTimeFin).endOf('day').valueOf();
			// Get all the user's
			return collectionData(query(collectionGroup(this.firestore, 'teams'), where("startTime", ">=", start), 
			where("startTime", "<=", end)), { idField: 'id' })
			.pipe(map(collection => {
				return collection.map(doc => {
					let team = new Team();
					team.fromJSON(doc);
					return team;
				});
			}));
		}else{
			if(gameId.length > 0) return this.listAllTeams(gameId)
			else return
		}
	}

	listTeamsByCode(code){
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where("password", "==", code)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	listTeamsByGroupId(groupId){
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where("groupId", "==", groupId)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	listTeamsByName(name){
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where("name", "==", name)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	listAllTeams(gameId){
		return collectionData(query(collectionGroup(this.firestore, 'teams')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	listAllTeamsGlobalSearch(val){
		return collectionData(query(collectionGroup(this.firestore, 'teams'), orderBy("name"), startAfter(val), startAt(val), endAt(val+"\uf8ff")), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team
			});
		}));
	}

	listLinkedTeams(gameId, originalTeamId){
		console.log('listLinkedTeams:'+gameId+'/'+originalTeamId);
		return collectionData(query(collection(this.firestore, `games/${gameId}/teams`), where('originalTeamId', '==', originalTeamId)), { idField: 'id' })
		.pipe(map(data => {
			return data.map(doc => {
				let team = new Team();
				team.fromJSON(doc.data());
				team.id = doc.id;
				return team;
			});
		}));
	}

	async fetchTeamJournal(gameId, teamId)
	{
		const team: any = await this.getTeam(gameId, teamId).pipe(take(1)).toPromise()

		const headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'text/html');

		team.players = []
		team.events = []
		team.objects = []
		team.riddleCount = 0
		team.clueCount = 0
		team.missionCount = 0
		team.teamPictureUrl = null
		team.leaderboardPosition = 1
		team.leaderboard = []

		const data = {
			lang: team.lang,
            teamId: teamId,
            gameId: gameId,
            teamData: team
		}
		console.log('fetchTeamJournal:'+JSON.stringify(data));
		return this.http.post(
			'https://www.coddygames.com/journal-api', 
			data, 
			{
				headers: headers, 
				responseType:'text'
			});
	}

	genTeamJournal(data){
		const headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'text/html');
		console.log('fetchTeamJournal:'+JSON.stringify(data));
		return this.http.post(
			'https://www.coddygames.com/journal-api', 
			data, 
			{
				headers: headers, 
				responseType:'text'
			});
	}

	getTeam(gameId, teamUid){
		console.log('getTeam:'+gameId+'/'+teamUid);
		return docData(doc(this.firestore, `games/${gameId}/teams/${teamUid}`))
		.pipe(map(teamData => {
			console.log('getTeam data:'+JSON.stringify(teamData));
			if(teamData){
				let team = new Team();
				team.fromJSON(teamData);
				team.id = teamUid;
				return team;
			}
			return null;
		}));
	}

	findTeam(email){
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where('email', '==', email)), { idField: 'id' })
		.pipe(map(data => {
			return data.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				team.id = doc.id;
				return team;
			});
		}));
	}
	findTeamByTeamCode(teamCode){
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where('password', '==', teamCode)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	getTeamByTicketId(ticketId){
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where("ticketId", "==", ticketId)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	getTeamByBookingRef(bookingRef){
		//console.log('getTeamByBookingRef:'+bookingRef);
		return collectionData(query(collectionGroup(this.firestore, 'teams'), where("bookingRef", "==", bookingRef)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	getTeamByBookingRefLike(bookingRef){
		console.log('getTeamByBookingRef:'+bookingRef);
		console.log('getTeamByBookingRef-endAt:'+bookingRef+'\uf8ff');
		return collectionData(query(collectionGroup(this.firestore, 'teams'), orderBy('bookingRef'), 
			startAt(bookingRef), endAt(bookingRef+'\uf8ff')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let team = new Team();
				team.fromJSON(doc);
				return team;
			});
		}));
	}

	isUniqueIdValid(id){
		return new Promise<boolean>(resolve => {
			return collectionData(query(collectionGroup(this.firestore, 'teams'), where('password', '==', id.toUpperCase()), 
			where('complete', '==', false)), { idField: 'id' })
			.pipe(take(1))
			.subscribe(teams => {
				if(teams && teams.length>0){
					resolve(false);
				}
				resolve(true);
			});
		});
	}
	
	addTeam(gameId, team) {
		return addDoc(collection(this.firestore, `games/${gameId}/teams`), {...team});
	}

	setTeam(gameId, teamUid, data){
		return setDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}`), data);
	}

	updateTeam(gameId, teamUid, data){
		return updateDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}`), data);
	}

	deleteTeam(gameId, teamUid) {
		return deleteDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}`));
	}

	async resetTeam(gameId, teamUid, groupUid) {
		getDocs(query(collection(this.firestore, `games/${gameId}/teams/${teamUid}/missions`)))
		.then(async data => {
			var batch = writeBatch(this.firestore);

			data.docs.forEach((mission: any) => {
				batch.delete(mission.ref);
			});

			// Commit the batch
			await batch.commit();

			/*missions.forEach(async a => {
				console.log('Delete mission '+a.id);
				await this.deleteTeamMission(gameId, teamUid, a.id);
			});*/
		});

		getDocs(query(collection(this.firestore, `games/${gameId}/teams/${teamUid}/objects`)))
		.then(async data => {
			var batch = writeBatch(this.firestore);

			data.docs.forEach((object: any) => {
				if(!object.data().ticketId){
					batch.delete(object.ref);
				}
			});

			// Commit the batch
			await batch.commit();
			/*object.forEach(async a => {
				console.log('Delete object '+a.id);
				await this.deleteTeamObject(gameId, teamUid, a.id);
			});*/
		});

		getDocs(query(collection(this.firestore, `games/${gameId}/teams/${teamUid}/events`)))
		.then(async data => {
			var batch = writeBatch(this.firestore);

			data.docs.forEach((event: any) => {
				batch.delete(event.ref);
			});

			// Commit the batch
			await batch.commit();
			/*events.forEach(async a => {
				console.log('Delete event '+a.id);
				await this.deleteTeamEvent(gameId, teamUid, a.id);
			});*/
		});

		getDocs(query(collection(this.firestore, `games/${gameId}/teams/${teamUid}/players`)))
		.then(async data => {
			var batch = writeBatch(this.firestore);

			data.docs.forEach((player: any) => {
				batch.update(player.ref, {
					roleId: deleteField(),
					startTime: deleteField()
				});
			});

			// Commit the batch
			await batch.commit();
			/*events.forEach(async a => {
				console.log('Delete event '+a.id);
				await this.deleteTeamEvent(gameId, teamUid, a.id);
			});*/
		});

		if(groupUid){
			getDocs(query(collection(this.firestore, `games/${gameId}/groups/${groupUid}/mission_scores`), where('teamId', '==', teamUid)))
			.then(async data => {
				if(data.docs.length>0){
					var batch = writeBatch(this.firestore);
		
					data.docs.forEach((score: any) => {
						batch.delete(score.ref);
					});
		
					// Commit the batch
					await batch.commit();
				}
			});
		}

		await this.updateTeam(gameId, teamUid, 
			{
				score:0, 
				progress:0, 
				completedSteps:0, 
				timeBonus:0, 
				open:true, 
				complete:false, 
				paused:false, 
				resuming:false, 
				failed:deleteField(), 
				initiated:deleteField(), 
				deadline:deleteField(), 
				startTime:deleteField(), 
				stopTime:deleteField(), 
				duration:deleteField(), 
				pauseDuration:deleteField(), 
				currentMissionId:deleteField(), 
				leaderPlayerId:deleteField(), 
				timerStopped:deleteField(), 
				fallbackMissionId:deleteField(), 
				finalMissionReached:deleteField(), 
				gameOverUrl:deleteField()
			});
	}

	deleteTeamPicture(gameId,teamId,eventId){
		return addDoc(collection(this.firestore, `picture_deletion_requests`), {
            time: new Date().getTime(),
            gameId: gameId,
            teamId: teamId,
            eventId: eventId
        })
	}

	updateTeamMission(gameId, teamUid, missionId, data){
		return updateDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}/missions/${missionId}`), data);
	}

	setTeamMission(gameId, teamUid, missionId, data){
		return setDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}/missions/${missionId}`), data);
	}

	async resetTeamMission(gameId, teamUid, missionId, active) {
		getDocs(query(collection(this.firestore, `games/${gameId}/teams/${teamUid}/missions`)))
		.then(async data => {
			data.docs.forEach(async (mission: any) => {
				if(mission.id == missionId){
					console.log('Delete mission '+mission.id);
					await deleteDoc(mission.ref);
					//await this.deleteTeamMission(gameId, teamUid, a.id);
					//let data = a.data();
					//let data:any = {};
					if(active){
						let data:any = {};
						data.orderNum = mission.data().orderNum;
						data.active = true;
						data.complete = false;
						data.activatedByApp = true;
						data.activeTime = new Date().getTime();
						data.activatedBy = 'webadmin';
						await setDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}/missions/${missionId}`), data, {merge:false});
					}
				}
			});
		});
	}

	deleteTeamMission(gameId, teamUid, missionId){
		return deleteDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}/missions/${missionId}`));
	}

	addTeamObject(gameId, teamId, object) {
		return addDoc(collection(this.firestore, `games/${gameId}/teams/${teamId}/objects`), {...object});
	}

	deleteTeamObject(gameId, teamUid, objectUid) {
		return deleteDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}/objects/${objectUid}`));
	}

	deleteTeamEvent(gameId, teamUid, eventId){
		return deleteDoc(doc(this.firestore, `games/${gameId}/teams/${teamUid}/events/${eventId}`));
	}

	listTeamPlayers(gameId, teamId){
		return collectionData(query(collection(this.firestore, `games/${gameId}/teams/${teamId}/players`)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let player = new Player();
				player.fromJSON(doc);
				return player;
			});
		}));
	}

	listTeamMissions(gameId, teamId){
		return collectionData(query(collection(this.firestore, `games/${gameId}/teams/${teamId}/missions`), orderBy('orderNum','asc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let mission = new Mission(`games/${gameId}/teams/${teamId}/missions`);
				mission.fromJSON(doc);
				return mission;
			});
		}));
	}

	listTeamEvents(gameId, teamId){
		return collectionData(query(collection(this.firestore, `games/${gameId}/teams/${teamId}/events`)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let event = new Event();
				event.fromJSON(doc);
				return event;
			});
		}));
	}

	listTeamMailings(gameId, teamId){
		return collectionData(query(collection(this.firestore, `games/${gameId}/teams/${teamId}/mailings`), orderBy('time','desc')), { idField: 'id' });
	}

	createMailing(gameUid, teamId, mailing){
		return addDoc(collection(this.firestore, `games/${gameUid}/teams/${teamId}/mailings`), {...mailing});
	}
}
